import { render, staticRenderFns } from "./Cancellation.vue?vue&type=template&id=30b36a26&scoped=true"
import script from "./Cancellation.vue?vue&type=script&lang=js"
export * from "./Cancellation.vue?vue&type=script&lang=js"
import style0 from "./Cancellation.vue?vue&type=style&index=0&id=30b36a26&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30b36a26",
  null
  
)

export default component.exports